<template>
  <page>
    <div :load="doInit">
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Selection Criteria</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
      <v-card>
        <v-card-text>
          <v-form>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs6>
                  <cal-picker
                    v-model="reportForm.tranDateFrom"
                    :label="labels.tranDateFrom"
                    v-validate="fromDateValidation(reportForm.tranDateFrom)"
                    :data-vv-as="labels.tranDateFrom"
                    data-vv-name="tranDateFrom"
                    :error-messages="errors.collect('tranDateFrom')"
                    :min="fromDateMinDate"
                    :max="fromDateMax()"
                  ></cal-picker>
                </v-flex>
                <v-flex xs6>
                  <cal-picker
                    v-model="reportForm.tranDateTo"
                    :label="labels.tranDateTo"
                    v-validate="toDateValidation(reportForm.tranDateTo)"
                    :data-vv-as="labels.tranDateTo"
                    data-vv-name="tranDateTo"
                    :error-messages="errors.collect('tranDateTo')"
                    :min="reportForm.tranDateFrom"
                    :max="today"
                  ></cal-picker>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete
                    :items="driList"
                    v-model="reportForm.dri"
                    :label="labels.dri"
                    item-text="label"
                    item-value="value"
                    data-vv-name="dri"
                    :data-vv-as="labels.dri"
                    :error-messages="errors.collect('dri')"
                    v-validate="'required'"
                    :loading="loading"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
      <v-spacer class="mt-2"></v-spacer>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
      <v-card>
        <v-card-text>
          <v-form>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="reportForm.polType"
                    :label="labels.polType"
                    :error-messages="errors.collect('polType')"
                    data-vv-name="polType"
                    :data-vv-as="labels.polType"
                    append-icon="mdi-magnify"
                    @click:append="getHelpList('polType')"
                    v-validate="'required'"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="reportForm.branch"
                    :label="labels.branch"
                    :error-messages="errors.collect('branch')"
                    data-vv-name="branch"
                    :data-vv-as="labels.branch"
                    append-icon="mdi-magnify"
                    @click:append="getHelpList('branch')"
                    v-validate="'required'"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="reportForm.agent"
                    :label="labels.agent"
                    :error-messages="errors.collect('agent')"
                    data-vv-name="agent"
                    :data-vv-as="labels.agent"
                    append-icon="mdi-magnify"
                    @click:append="getHelpList('agent')"
                    readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
      </v-layout>
      </v-container>
      <v-spacer class="mt-4"></v-spacer>
              <v-flex xs12 sm12 md12 lg12>
          <v-layout class="d-flex align-center">
            <v-btn class="mr-3" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
              <v-icon left dark>mdi-file-export</v-icon>
              {{ labels.export }}
            </v-btn>
            <v-btn-toggle class="mr-10" dense mandatory v-model="reportForm.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{ format.label }}</span>
                <v-icon :color="format.color">{{ format.icon }}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-layout>
        </v-flex>
      <v-dialog v-model="helplist" width="900px" persistent>
        <helplist v-if="helplist" :apiURI="apiURI" :mode="mode" :param="param" @close="doClose" @doAssign="doAssign($event)"></helplist>
      </v-dialog>
      <v-dialog v-model="optHelplist" width="900px" persistent>
        <optHelplist v-if="optHelplist" :apiURI="apiURI" :mode="mode" :param="param" @close="doClose" @doAssign="doAssign($event)"></optHelplist>
      </v-dialog>

      <v-dialog v-model="submitting" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Processing...{{ submitLabel }}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </page>
</template>

<script>
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import Helplist from '../helplist/Helplist'
import OptHelplist from '../helplist/OptionalHelplist'
import { checkDateRangeFrom, checkDateRangeTo, driList } from './index'

export default {
  data() {
    return {
      labels: {
        dateRange: 'Date Ranges',
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        branch: 'Branch',
        dri: 'Direct / RI',
        polType: 'Policy Type',
        agent: 'Exclude Account Nos.',
        export: 'Export to'
      },
      reportForm: {
        tranDateFrom: undefined,
        tranDateTo: new Date(),
        branch: 'All',
        dri: 'All',
        polType: 'All',
        agent: '',
        format: 'TXT'
      },
      // HelpList
      helplist: false,
      optHelplist: false,
      apiURI: '',
      mode: '',
      param: '',
      // Other
      today: new Date(),
      fromDateMinDate: new Date(2000, 0, 1),
      menu: {},
      loading: false,
      submitting: false,
      driList: [],
      submitLabel: undefined,
      supportedFormat: ['TXT'],
      panel1: [0],
      panel2: [0]
    }
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    dtMenu() {
      return this.$store.state.underwriting.dataTransferSettings.menu
    }
  },
  methods: {
    async doInit() {
      try {
        const apiURI = this.dtMenu.initTravelClaimsGIA
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      if (fieldName === 'branch') {
        this.helplist = true
        this.apiURI = this.menu.getBranchList
        this.param = this.reportForm.branch
      } else if (fieldName === 'polType') {
        this.helplist = true
        this.apiURI = this.menu.getPolTypeList
        this.param = this.reportForm.polType
      } else if (fieldName === 'agent') {
        this.optHelplist = true
        this.apiURI = this.menu.getAgentList
        this.param = this.reportForm.agent
      }
    },
    doClose() {
      this.helplist = false
      this.optHelplist = false
    },
    doAssign(Obj) {
      if (this.mode === 'branch') {
        this.reportForm.branch = ''
        this.reportForm.branch = Obj.finalSelectedItems.toString()
      } else if (this.mode === 'polType') {
        this.reportForm.polType = ''
        this.reportForm.polType = Obj.finalSelectedItems.toString()
      } else if (this.mode === 'agent') {
        this.reportForm.agent = ''
        if (Obj.finalSelectedItems === undefined) {
          this.reportForm.agent = ''
        } else {
          this.reportForm.agent = Obj.finalSelectedItems.toString()
        }
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          // this.doDownloadGIA().then(() => {
          //   this.doGenerateGIA()
          // })
          this.doGenerateGIA()
        }
      })
    },
    async doDownloadGIA() {
      const apiURI = this.menu.downloadTxt
      if (apiURI) {
        try {
          this.submitting = true
          this.submitLabel = 'Text File'
          await this.$http.post(apiURI, this.reportForm)

          // if (result.data) {
          //   var headers = result.headers
          //   var blob = new Blob([result.data], { type: headers['content-type'] })
          //   var filename = (headers['content-disposition'] || 'file').split('filename=')[1]
          //   downloadPrompt(blob, filename)
          // }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doGenerateGIA() {
      const apiURI = this.menu.generateRpt
      if (apiURI) {
        try {
          this.submitting = true
          this.submitLabel = 'Audit File'
          await this.$http.post(apiURI, this.reportForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.submitting = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    fromDateMax() {
      if (this.reportForm.toDate1) {
        return this.reportForm.toDate1
      } else {
        return new Date(2070, 11, 31)
      }
    },
    fromDateValidation(toDate1) {
      if (toDate1) {
        return 'required|checkDateRangeFrom:' + toDate1
      } else {
        return 'required|checkDateRangeFrom'
      }
    },
    toDateValidation(fromDate1) {
      if (fromDate1) {
        return 'required|checkDateRangeTo:' + fromDate1
      } else {
        return 'required|checkDateRangeTo'
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  created() {
    this.driList = driList
    this.$validator.extend('checkDateRangeFrom', checkDateRangeFrom)
    this.$validator.extend('checkDateRangeTo', checkDateRangeTo)
  },
  mixins: [MessageMixin],
  components: {
    Helplist,
    OptHelplist
  }
}
</script>
